import { render, staticRenderFns } from "./PageMyGoals.vue?vue&type=template&id=59360192&"
import script from "./PageMyGoals.vue?vue&type=script&lang=js&"
export * from "./PageMyGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports